module.exports = __webpack_public_path__ + "img/Proliferation-PDAC_GSE202740.e721eee3.png";